import { gql } from '@apollo/client'

export const SUBSCRIBE_TO_NEWSLETTER = gql`
    mutation SubscribeToNewsletter (
        $email: String,
        $firstname: String,
        $lastname: String,
        $country: String
    ) {
        sendinblueSignUp(
            email: $email,
            firstname: $firstname,
            lastname: $lastname,
            country: $country
        )
    }
`
